import { useTheme } from "../contexts/ThemeContext"
import LanguageSwitcher from "./LanguageSwitcher"
import useTranslation from "../hooks/useTranslation"
import { useState } from "react"

const Navbar = () => {
  const { t, currentLanguage: language } = useTranslation()
  const { headerLogo } = useTheme()
  const [imageError, setImageError] = useState(false)

  return (
    <nav className="flex items-center justify-between px-3 sm:px-5 py-3 sm:py-5 bg-white shadow-lg shadow-gray-100">
      {/* Right: Logo */}
      <div className="flex items-center space-x-2 space-x-reverse">
        {headerLogo && !imageError ? (
          <img
            src={headerLogo}
            alt={t('restaurant.logo')}
            className="h-8 object-contain"
            onError={() => setImageError(true)}
          />
        ) : (
          // Fallback logo with text
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg text-gray-800">
              {t('restaurant.brandName')}
            </span>
            <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
            </div>
          </div>
        )}
        <div className="text-right leading-tight"></div>
      </div>

      {/* Left: Language Switcher */}
      <div className="flex items-center">
        <LanguageSwitcher />
      </div>
    </nav>
  )
}

export default Navbar
